import { render, staticRenderFns } from "./NewsTrendDetail.vue?vue&type=template&id=59c89fc4"
import script from "./NewsTrendDetail.vue?vue&type=script&lang=js"
export * from "./NewsTrendDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports